/* Live commerce footer: add-to-cart (/cart/add.js with footer attribution) + GA4
   article_footer funnel events. Progressive enhancement over plain product links.
   Integrates with the theme's Dawn-style cart drawer / notification so the cart UI
   updates instantly (Section Rendering API + renderContents), no page refresh. */
(function () {
 // Each shop block on the page (the guide's "In stock from this set" strip near the top and the footer) gets
 // the same add-to-cart; data-list / data-source keep their GA4 list and cart attribution separate.
 function init(root) {
  // The script can be included by several sections on one page; set each block up once, or one tap adds twice.
  if (root.hasAttribute('data-mcc-ready')) return;
  root.setAttribute('data-mcc-ready', '');
  var article = root.getAttribute('data-article') || '';
  var LIST = root.getAttribute('data-list') || 'article_footer';
  var LIST_NAME = root.getAttribute('data-list-name') || 'Article Footer';
  var SOURCE = root.getAttribute('data-source') || 'commerce_footer';

  // The active cart UI element (drawer or notification). One of these is on
  // every page via the theme header; null only when cart type = "page".
  function cartUI() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  function ga(name, params) {
    try {
      if (window.gtag) window.gtag('event', name, params);
      else (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, params));
    } catch (e) {}
  }
  function cardItem(card, i) {
    return {
      item_id: card.getAttribute('data-pid'),
      item_name: card.getAttribute('data-title'),
      price: parseFloat(card.getAttribute('data-price')) || undefined,
      index: i,
      item_list_id: LIST,
      item_list_name: LIST_NAME
    };
  }
  function items() {
    return Array.prototype.map.call(root.querySelectorAll('[data-mcc-card]'), cardItem);
  }

  // Fallback for cart type = "page": refresh just the header cart count bubble.
  function refreshCartBubble() {
    var el = document.getElementById('cart-icon-bubble');
    if (!el) return;
    fetch(window.location.pathname + '?sections=cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var html = d && d['cart-icon-bubble'];
        if (!html) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var inner = tmp.querySelector('.shopify-section');
        el.innerHTML = inner ? inner.innerHTML : tmp.innerHTML;
      })
      .catch(function () {});
  }

  // view_item_list — once, when the footer scrolls into view
  var fired = false;
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting && !fired) {
          fired = true;
          ga('view_item_list', { item_list_id: LIST, item_list_name: LIST_NAME, items: items() });
          io.disconnect();
        }
      });
    });
    io.observe(root);
  }

  // select_item — clicking a card (but not the add-to-cart button)
  root.addEventListener('click', function (ev) {
    var card = ev.target.closest('[data-mcc-card]');
    if (card && !ev.target.classList.contains('mcc-atc')) {
      ga('select_item', { item_list_id: LIST, item_list_name: LIST_NAME, items: [cardItem(card, 0)] });
    }
  });

  // add_to_cart — /cart/add.js with footer attribution + live cart UI update
  root.addEventListener('click', function (ev) {
    function announce(msg) {
      var live = document.getElementById('mcc-atc-live');
      if (!live) {
        live = document.createElement('div'); live.id = 'mcc-atc-live'; live.setAttribute('role', 'status');
        live.style.cssText = 'position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap';
        document.body.appendChild(live);
      }
      live.textContent = ''; setTimeout(function () { live.textContent = msg; }, 50);
    }
    var btn = ev.target.closest('.mcc-atc');
    if (!btn) return;
    ev.preventDefault();
    ev.stopPropagation();
    var card = btn.closest('[data-mcc-card]');
    var vid = parseInt(btn.getAttribute('data-variant'), 10);
    if (!vid) return;
    btn.disabled = true;
    var label = btn.textContent;
    btn.textContent = 'Adding…';

    var cart = cartUI();
    var body = { items: [{ id: vid, quantity: 1, properties: { _source: SOURCE, _article: article } }] };
    // Ask Shopify to render the cart sections so the drawer/notification updates.
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (response) {
        // Shopify sets `status` on error responses (e.g. 422 sold out).
        if (response && response.status && Number(response.status) >= 400) {
          // Sold out since the page loaded: say so for good (no retry loop). Other refusals: brief message, then retry is allowed.
          var gone = /sold out|out of stock/i.test(String(response.description || response.message || ''));
          if (gone) {
            btn.textContent = 'Sold out';
            if (card) card.classList.add('is-soldout');
            announce((card && card.getAttribute('data-title') || 'This product') + ' has just sold out.');
          } else {
            btn.textContent = 'Unavailable';
            announce(String(response.description || 'This product could not be added.'));
            setTimeout(function () { btn.disabled = false; btn.textContent = label; }, 2500);
          }
          return;
        }
        ga('add_to_cart', { currency: 'GBP', items: [Object.assign(cardItem(card, 0), { quantity: 1 })] });
        btn.textContent = 'Added ✓';
        try {
          if (cart && typeof cart.renderContents === 'function') {
            if (typeof cart.setActiveElement === 'function') cart.setActiveElement(btn);
            // The theme's own product form clears the drawer's empty state; without this the drawer opens on
            // "Your cart is empty" after a first add. Then tell the free-shipping bar the cart changed, as the form does.
            if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
            cart.renderContents(response);
            document.dispatchEvent(new CustomEvent('afterCartChanged', { detail: { productVariantId: vid, source: SOURCE, cartData: response } }));
          } else {
            refreshCartBubble();
          }
        } catch (e) { refreshCartBubble(); }
        setTimeout(function () { btn.disabled = false; btn.textContent = label; }, 1800);
      })
      .catch(function () { btn.disabled = false; btn.textContent = label; });
  });
 }
 Array.prototype.forEach.call(document.querySelectorAll('#mcc-commerce-footer, [data-mcc-shop]'), init);
})();
